import { designTokens } from '@/utils/design-tokens'
import { formatRate, getRateColor, strategyColors } from '../strategyMetrics'

interface RateBarProps {
  rate: number | null
  /** card: 카드 안 작은 막대(라벨 포함) / table: 표 칸 막대 */
  variant?: 'card' | 'table'
  label?: string
  /** 진한 배경 카드 위에 그릴 때 */
  inverse?: boolean
}

const font = designTokens.typography.fontFamily.sans[0]

/** 가로 막대 + %. 해당 없음은 빈 막대 + 회색 "—" */
export default function RateBar({
  rate,
  variant = 'table',
  label,
  inverse = false,
}: RateBarProps) {
  const hasValue = rate != null
  const width = hasValue ? Math.min(Math.max(rate, 0), 100) : 0
  const isCard = variant === 'card'
  const barHeight = isCard ? 6 : 8

  const bar = (
    <span
      style={{
        display: 'block',
        flexGrow: 1,
        height: barHeight,
        background: inverse ? strategyColors.darkTrack : strategyColors.track,
        borderRadius: barHeight / 2,
        overflow: 'hidden',
      }}
    >
      {hasValue && (
        <span
          style={{
            display: 'block',
            width: `${width}%`,
            height: '100%',
            borderRadius: barHeight / 2,
            background: getRateColor(rate, inverse),
          }}
        />
      )}
    </span>
  )

  const value = (
    <span
      style={{
        fontFamily: font,
        fontSize: 14,
        minWidth: isCard ? undefined : 52,
        textAlign: 'right',
        fontWeight: hasValue ? 700 : 400,
        color: inverse
          ? hasValue
            ? strategyColors.surface
            : strategyColors.darkSubText
          : hasValue
            ? strategyColors.text
            : strategyColors.mutedText,
        fontVariantNumeric: 'tabular-nums',
      }}
    >
      {formatRate(rate)}
    </span>
  )

  if (isCard) {
    return (
      <span
        style={{
          display: 'grid',
          gridTemplateColumns: '72px minmax(0, 1fr) 56px',
          gap: 8,
          alignItems: 'center',
          fontFamily: font,
          fontSize: 14,
        }}
      >
        <span
          style={{
            color: inverse
              ? strategyColors.darkSubText
              : strategyColors.subText,
          }}
        >
          {label}
        </span>
        {bar}
        {value}
      </span>
    )
  }

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
      {bar}
      {value}
    </div>
  )
}
